function sunTimes(date, lat, lon) {
  var rad = Math.PI / 180;
  var dayMs = 86400000;

  // Anchor the day at UTC midnight (critical fix)
  var d0 = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

  function toJulian(d) { return (d.getTime() / dayMs) - 0.5 + 2440588; }
  function fromJulian(j) { return new Date((j + 0.5 - 2440588) * dayMs); }

  var J = toJulian(d0);

  // East-positive longitude (Melbourne is +144.9631)
  var n = Math.round(J - 2451545.0009 - (lon / 360));
  var Jstar = 2451545.0009 + (lon / 360) + n;

  var M = (357.5291 + 0.98560028 * (Jstar - 2451545)) * rad;
  var C = (1.9148 * Math.sin(M) + 0.0200 * Math.sin(2 * M) + 0.0003 * Math.sin(3 * M)) * rad;
  var lambda = M + C + (180 + 102.9372) * rad;

  var Jtransit = Jstar + (0.0053 * Math.sin(M)) - (0.0069 * Math.sin(2 * lambda));

  var delta = Math.asin(Math.sin(lambda) * Math.sin(23.44 * rad));
  var phi = lat * rad;
  var h0 = (-0.83) * rad;

  var cosw = (Math.sin(h0) - Math.sin(phi) * Math.sin(delta)) / (Math.cos(phi) * Math.cos(delta));
  if (cosw > 1 || cosw < -1) return { sunrise: null, sunset: null };

  var w = Math.acos(cosw);
  var Jrise = Jtransit - (w / (2 * Math.PI));
  var Jset  = Jtransit + (w / (2 * Math.PI));

  return { sunrise: fromJulian(Jrise), sunset: fromJulian(Jset) };
}
